import React, { useCallback, useState } from 'react';
import { Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useFetchEntitySingle } from '../../Services/fetchApi';
import Modal from './Modal';
import FormContainer from './FormContainer';
import useFunction from '../../utils/Hooks/useFunction';
import { useAlert } from '../../Services/AlertContext';
import { useEffect } from 'react';
import EditorTitle from './EditorTitle';
import ExtraDataModal from './ExtraDataModal';
import { endpoints } from '../../utils/Constants';
import { useAuth } from '../../Services/AuthContext';
import LoadingAnimation from '../Form/LoadingAnimation';
import useFetchSimple from '../../Services/useFetchSimple';
import useFetch from '../../Services/useFetch';
import { base64Encode } from '../../utils/Helpers';


const RouteModal = ({ route, appRoute, parentEntityItem, onClose, appRoutes }) => {
    const alert = useAlert();
    const [extraData, setExtraData] = useState(appRoute.extraData);
    const [actions, setActions] = useState([])
    const [auth] = useAuth();
    const [state, dispatch] = useState(true);
    const [item, setItem] = useState();
    const [editState, setEditState] = useState(appRoute.edit ? appRoute.edit(item) : true);
    const [originalValues, setOriginalValues] = useState();
    const fetch = useFetchSimple();
    const { entity } = appRoute;
    const [statusDetail, loadingStatus, loadingStatusError] = useFetch(entity && entity.name && item && item.status ? endpoints.getStatusForEntityAndStatus + entity.name + '/' + item.status : null);
    const [submitting, setSubmit] = useState();
    const secondEntity = entity.seconadaryEntity && entity.seconadaryEntity.value && item && item[entity.seconadaryEntity.value] ? item[entity.seconadaryEntity.value] : null;

    const [allowedActions1, loadingActions1, loadingError1] = useFetch((item && !item.id) ? endpoints.getActionsForEntity + entity.name : item && entity ? endpoints.getActionsForEntityItem + entity.name + '/' + item.id : null);
    const [allowedActions2, loadingActions2, loadingError2] = useFetch((item && !item.id) ? endpoints.getActionsForEntity + entity.name : item && secondEntity ? endpoints.getActionsForEntityItem + entity.seconadaryEntity.name + '/' + item[entity.seconadaryEntity.value].id : null);
    const [loadedItem, loadingItem, loadingItemError] = useFetchEntitySingle(entity.fetchItemId ? entity : null, entity.fetchItemId ? parentEntityItem[entity.fetchItemId(parentEntityItem)] : null, true);
    const loading = loadingActions1 || loadingActions2;
    const loadingError = loadingError1 || loadingError2 || loadingStatusError || loadingItemError;

    useEffect(() => {
        if (item && !editState) {
            setEditState(appRoute.edit ? appRoute.edit(item) : true);
        }
    }, [item, appRoute, editState]);
    useEffect(() => {
        if (loadedItem) {
            var item = loadedItem ? (appRoute.entity.prepareForEdit ? appRoute.entity.prepareForEdit(loadedItem) : loadedItem) : null;

            setItem(item);
        }
    }, [loadedItem, appRoute.entity]);
    const { push } = useHistory();
    const onCloseEditor = useCallback(() => {
        state.onDismiss && state.onDismiss();
        dispatch();
        push(route);
        onClose();
    }, [push, dispatch, state, onClose, route]);

    const [handleSubmit, setHandleSubmit] = useFunction();
    const [myAppRoute, setAppRoute] = useState();
    useEffect(() => {
        if (!item && entity && parentEntityItem) {
            if (!entity.fetchItemId) {
                var nitem = appRoute.entity.prepareForEdit ? appRoute.entity.prepareForEdit(parentEntityItem) : parentEntityItem;
                setItem(nitem);
            }
        }
    }, [parentEntityItem, item, entity, appRoute.entity]);
   

    const doFetch = useCallback((url, post, actions) => {

        let requestBody = JSON.stringify(post);

        let encodingRequests=["sendemails","newbid","aircraft/add","aircraft/update","newcharterrequest",
                                      "clonecharterrequest","updatecharterrequest","updatechangecharter","updatemanifest",
                                      "newchangecharter","updatechartershare","updatechartersharepurchase","updateterms"];    

        if (url && encodingRequests.some(req => url.toLowerCase().includes(req))) {
            requestBody = JSON.stringify({ encodedData: base64Encode(requestBody) });
        }

        return fetch(url, { method: 'POST', body: requestBody }).then((result) => {
            const ret = result.body;
            const m = ret.messages;
            const isCloneJobSave = entity.title?.toLowerCase().includes("clone");

            const entityTitle = <h5>{entity.title + ' ' + ((result?.response?.ok && isCloneJobSave) ? ("JB" + result.body?.result?.jobReference) : entity.getTitle(post))}</h5>;
            const saveMessage = (result?.response?.ok) ? (entity.saveMessage ? (!isCloneJobSave ? entity.saveMessage(post) : entity.saveMessage(result.body?.result?.jobReference)) : entityTitle) : <h5>Error Saving {entity.tile}</h5>;

            alert({
                title: appRoute.entity.title, body: <div>
                    {saveMessage}
                    {m && m.length ? m.map(x => <p>{x}</p>) : null}
                </div>
                , onDismiss: () => {
                    onCloseEditor();
                }
            })

        }, (error) => {
            var isForbiddenError = JSON.stringify(error)?.toLocaleLowerCase().includes("403 forbidden");

            alert({
                title: 'Error saving ' + entity.title, body: !isForbiddenError ? error?.body?.error :
                    "An unexpected error has occurred while saving. Please contact Avmin team."
            });
            console.log("Error:" + error);

            try {
                var input = {
                    "code": "400",
                    "description": JSON.stringify(error)
                }

                fetch(endpoints.logError, { method: 'POST', body: JSON.stringify(input) }).then((result) => {
                }, (error1) => {
                    console.log("Failed to log error:" + error1);
                })
            }
            catch (ex) {
                console.log("Exception Occurred")
                console.log(ex)
            }

            actions && actions.setSubmitting && actions.setSubmitting(false);
        })

    }, [entity, appRoute, fetch, alert, onCloseEditor])

    const doSubmit = useCallback((values, actions) => {
        if (appRoute?.controls?.length && !extraData) {
            setExtraData(appRoute.controls);
            setOriginalValues(values);
            actions && actions.setSubmitting && actions.setSubmitting(false);
        } else {
            const post = entity.beforeSave ? entity.beforeSave({ ...values, ...extraData, status: appRoute?.action?.nextState }) : { ...values, ...extraData, status: appRoute?.action?.newStatus };
            doFetch(entity.addSingle, post, actions);

        }
    }, [appRoute, entity, doFetch, extraData]);
    useEffect(() => {

        const deleteItem = () => {
            const url = entity.removeSingle + item.id;
            doSubmit(url, {});
        }
        if (item && allowedActions1 && auth) {
            const test = 'canEdit' + auth.role;
            let canEdit = false;
            if (statusDetail && statusDetail[test] && !editState) {
                canEdit = true;
            }
            const allowed1 = editState ? [] : allowedActions1 ? allowedActions1.filter(x => x.allowedRole === auth.role && x.entityState === item.status) : null;
            const allowed2 = editState || !secondEntity ? [] : allowedActions2 ? allowedActions2.filter(x => x.allowedRole === auth.role && x.entityState === secondEntity.status) : null;

            const newActions = () => {

                return submitting || loading || loadingStatus ? <LoadingAnimation height='40px' /> : <React.Fragment >
                    {(item && !editState && entity.removeSingle) && <Button onClick={() => deleteItem()}>Delete</Button>}
                    {canEdit && !editState && <Button onClick={() => setEditState(!editState)}>Edit</Button>}
                    {(editState) ?
                        <Button onClick={handleSubmit}>Save {appRoute?.action?.actionName}</Button> : null}

                    {
                        allowed1 && allowed1.map((x, i) => {
                            const updateItem = {
                                id: item.id,
                                allowedActionId: x.id,
                                entity: entity.name,
                                currentStatus: item.status,
                                newStatus: x.nextState,
                                reason: 'No Reason.'
                            }

                            const handleClick = () => {
                                const controls = x.dataEntry.filter(x =>
                                    x.dataEntryFilter === 'All'
                                    || (x.dataEntryFilter === 'QGov' && item.qGov)
                                    || (x.dataEntryFilter === 'NotQGov' && !item.qGov))
                                if (x.actionType === "Route") {

                                    const routeDefinition = { ...appRoutes[x.appRoute], controls, action: x };
                                    setAppRoute(routeDefinition);
                                }
                                else {


                                    if (controls.length === 0) {
                                        doFetch(endpoints.setItemStatus, { ...updateItem, ...item });
                                    }
                                    else {
                                        setExtraData({ controls, action: x });

                                    }
                                }
                            }

                            return <Button key={i} onClick={() => handleClick()}>{x.actionName}</Button>
                        })

                    }
                    {allowed2 && allowed2.map((x, i) => {
                        const updateItem = {
                            id: secondEntity.id,
                            allowedActionId: x.id,
                            entity: entity.seconadaryEntity.name,
                            currentStatus: secondEntity.status,
                            newStatus: x.nextState,
                            reason: 'No Reason.'
                        }

                        const handleClick = () => {
                            const controls = x.dataEntry.filter(x =>
                                x.dataEntryFilter === 'All'
                                || (x.dataEntryFilter === 'QGov' && item.qGov)
                                || (x.dataEntryFilter === 'NotQGov' && !item.qGov))
                            if (x.actionType === "Route") {

                                const routeDefinition = { ...appRoutes[x.appRoute], controls, action: x };
                                setAppRoute(routeDefinition);
                            }
                            else {


                                if (controls.length === 0) {
                                    doFetch(endpoints.setItemStatus, { ...updateItem, ...item });
                                }
                                else {
                                    setExtraData({ controls, action: x });

                                }
                            }
                        }

                        return <Button key={i} onClick={() => handleClick()}>{x.actionName}</Button>
                    })
                    }
                </React.Fragment >
            }
            setActions(newActions);
        }


    }, [doFetch, doSubmit, entity, item, allowedActions1, statusDetail, editState, auth, loading, loadingStatus, route, allowedActions2, secondEntity, appRoute, appRoutes, handleSubmit, submitting]);


    const closeExtraData = (v) => {
        if (v) {
            doSubmit(originalValues, null, v);
        }
        setExtraData();
    }

    return (<React.Fragment>
        {extraData ? <ExtraDataModal extraData={appRoute.controls} onClose={closeExtraData} /> : null}
        {myAppRoute ? <RouteModal appRoutes={appRoutes} appRoute={myAppRoute} parentEntity={entity} parentEntityItem={item} route={route} onClose={() => setAppRoute()} /> : null}
        <Modal open={state && entity} onClose={onCloseEditor} title={<EditorTitle entity={entity} detail={item} />} actions={actions} heightOffset={entity?.heightOffset} isPassengerModal={entity?.name === "Manifest"} >

            {state && entity && !loadingItem ? <FormContainer initialValues={{ ...item }} validationSchema={entity.validationSchema} edit={editState} newRequest={true} setHandleSubmit={setHandleSubmit} onSubmit={doSubmit} setSubmitting={setSubmit}>
                {entity.editor({ invite: appRoute.appRoute === 'new' ? true : false, item: parentEntityItem })}
                {loadingError ? <h6>Error Loading</h6> : null}
            </FormContainer > : null}
        </Modal>
    </React.Fragment>


    )
}



export default RouteModal; 